// Sidebar footer — company logo / user avatar + email + role + logout.
// Collapsed: stacked avatar + icon-only logout button.

import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

function CompanyOrAvatar({ companyLogo, user, title }) {
  if (companyLogo) {
    return (
      <div
        className="w-8 h-8 rounded-md overflow-hidden flex items-center justify-center flex-shrink-0"
        style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}
        title={title}
      >
        <img src={companyLogo} alt={user?.company_name || 'Company'} className="w-full h-full object-contain" />
      </div>
    );
  }
  return (
    <div
      className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0"
      style={{ background: 'rgba(69,117,168,0.18)', color: 'var(--strata-steel-2)', fontFamily: 'var(--strata-font-display)' }}
      title={title}
    >
      {user?.name?.charAt(0)?.toUpperCase() || 'U'}
    </div>
  );
}

export function SidebarFooter({ collapsed, user, companyLogo, onLogout }) {
  if (collapsed) {
    return (
      <div className="p-3 flex flex-col items-center gap-2" style={{ borderTop: '1px solid var(--strata-sidebar-border)' }}>
        <CompanyOrAvatar
          companyLogo={companyLogo} user={user}
          title={`${user?.name || 'User'} · ${user?.email || ''}`}
        />
        <Button
          data-testid="logout-button"
          variant="ghost"
          onClick={onLogout}
          title="Sign Out"
          className="w-9 h-9 p-0 flex items-center justify-center"
          style={{ color: 'var(--strata-sidebar-text)' }}
        >
          <LogOut className="w-4 h-4" />
        </Button>
      </div>
    );
  }
  return (
    <div className="p-3" style={{ borderTop: '1px solid var(--strata-sidebar-border)' }}>
      <div className="flex items-center gap-3 mb-2 px-2">
        <CompanyOrAvatar
          companyLogo={companyLogo} user={user}
          title={user?.company_name || 'Company'}
        />
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold truncate" style={{ color: 'var(--strata-sidebar-text-strong)', fontFamily: 'var(--strata-font-body)' }}>
            {user?.name || 'User'}
          </p>
          <p className="text-[10px] truncate" style={{ color: 'var(--strata-sidebar-text)', fontFamily: 'var(--strata-font-body)' }}>
            {user?.role} · {user?.email}
          </p>
        </div>
      </div>
      <Button
        data-testid="logout-button"
        variant="ghost"
        onClick={onLogout}
        className="w-full justify-start gap-3 text-xs h-9"
        style={{ color: 'var(--strata-sidebar-text)', fontFamily: 'var(--strata-font-body)', letterSpacing: '0.02em' }}
      >
        <LogOut className="w-4 h-4" />
        Sign Out
      </Button>
    </div>
  );
}
